// FastAPI架构配置
export interface ApiConfig {
  baseURL: string;
  backend: 'fastapi';
  port: number;
  name: string;
  description: string;
}

// Rails BFF + FastAPI算法服务配置
// 使用更可靠的方式判断是否为生产环境
const isProduction = window.location.hostname !== 'localhost' &&
                     window.location.hostname !== '127.0.0.1' &&
                     !window.location.hostname.includes('192.168');

export const API_CONFIG: ApiConfig = {
  // 使用相对路径，自动适应当前域名（keban.biguzaixian.com）
  // Rails路由已包含/api前缀，Nginx代理到localhost:3000
  baseURL: '/api',
  backend: 'fastapi',
  port: 3000,
  name: 'Rails BFF + FastAPI算法服务',
  description: 'Rails作为前端API，内部调用FastAPI算法服务'
};

class ApiConfigManager {
  private config: ApiConfig;

  constructor() {
    this.config = API_CONFIG;
    console.log(`🔧 API配置管理器初始化: ${this.config.name}`);
  }

  // 获取当前API配置
  getCurrentConfig(): ApiConfig {
    return { ...this.config };
  }

  // 获取API基础URL
  getBaseURL(): string {
    return this.config.baseURL;
  }

  // 构建完整的API URL
  buildApiUrl(endpoint: string): string {
    // 移除端点开头的斜杠以避免重复
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    const baseURL = this.config.baseURL.endsWith('/')
      ? this.config.baseURL.slice(0, -1)
      : this.config.baseURL;

    return `${baseURL}/${cleanEndpoint}`;
  }

  // 获取配置特性
  getBackendSpecificConfig() {
    return {
      timeout: 10000, // 10秒超时
      retries: 3,
      // FastAPI特定配置
      features: {
        algorithmSupport: true,
        riskAssessment: true,
        functionalCapability: true
      }
    };
  }

  // 获取当前配置摘要（用于调试）
  getConfigSummary(): string {
    return `${this.config.name} (${this.config.baseURL})`;
  }
}

// 导出单例实例
export const apiConfigManager = new ApiConfigManager();

// 导出类型和默认实例
export default apiConfigManager;